var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalProducts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#EBEFF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 14.3333V9.66665C17.2498 9.46206 17.1958 9.26112 17.0934 9.084C16.991 8.90687 16.8438 8.75978 16.6667 8.65748L12.5833 6.32415C12.406 6.22175 12.2048 6.16785 12 6.16785C11.7952 6.16785 11.594 6.22175 11.4167 6.32415L7.33333 8.65748C7.15615 8.75978 7.00899 8.90687 6.9066 9.084C6.80422 9.26112 6.75021 9.46206 6.75 9.66665V14.3333C6.75021 14.5379 6.80422 14.7388 6.9066 14.916C7.00899 15.0931 7.15615 15.2402 7.33333 15.3425L11.4167 17.6758C11.594 17.7782 11.7952 17.8321 12 17.8321C12.2048 17.8321 12.406 17.7782 12.5833 17.6758L16.6667 15.3425C16.8438 15.2402 16.991 15.0931 17.0934 14.916C17.1958 14.7388 17.2498 14.5379 17.25 14.3333Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.90747 9.06006L12 12.0059L17.0925 9.06006",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.88V12",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalProducts);
export default __webpack_public_path__ + "static/media/TotalProducts.af821c2caf92f100f6542707d7d72fdf.svg";
export { ForwardRef as ReactComponent };